import { useEffect, useState } from "react";
import ReactQuill from "react-quill";

import "./TextEditor.scss";

let textEditorCount = 0;

type Props = {
  id?: string;
  value: string;
  placeholder: string;
  onChange: (value: string) => void;
  showToolbar?: boolean;
};

function TextEditor({
  id = "texteditor",
  value,
  placeholder = "",
  onChange,
  showToolbar = true
}: Props) {
  const [toolbarId, setToolbarId] = useState("");

  useEffect(() => {
    setToolbarId(`${id}-toolbar-${textEditorCount++}`);
  }, [id]);

  if (!toolbarId) {
    return <></>;
  }

  return (
    <div className="text-editor">
      {showToolbar && (
        <div id={toolbarId} className="mb-3">
          <button className="ql-bold" />
          <button className="ql-italic" />
          <button className="ql-underline" />
          <button className="ql-link" />
          <button className="ql-list" value="bullet" />
        </div>
      )}

      <ReactQuill
        id={id}
        className=""
        theme="snow"
        onChange={onChange}
        modules={{
          toolbar: showToolbar
            ? {
                container: `#${toolbarId}`
              }
            : false
        }}
        placeholder={placeholder}
        value={value}
      />
    </div>
  );
}

export default TextEditor;
